import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';

import {
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

import { SitesService } from '@models/sites/sites.service';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { AuthService } from '@shared/store/auth/auth.service';
import { EventQuery } from '@shared/store/event/event.query';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouteTabGroupComponent],
  selector: 'aux-forecast-site-drivers',
  templateUrl: './forecast-site-drivers.component.html',
})
export class ForecastSiteDriversComponent {
  authService = inject(AuthService);
  eventQuery = inject(EventQuery);
  launchDarklyService = inject(LaunchDarklyService);
  sitesService = inject(SitesService);
  workflowQuery = inject(WorkflowQuery);

  tabs: TabGroupConfig[] = [
    { label: 'Site Curves', route: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.SITE_DRIVER.CURVES },
    {
      label: 'Site Groups',
      route: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.SITE_DRIVER.GROUPS,
      show: this.launchDarklyService.select$((flags) => flags.tab_forecast_site_groups),
    },
  ];

  constructor() {
    this.sitesService.get().pipe(takeUntilDestroyed()).subscribe();
  }
}
